import api from 'lib/api';


export const getUserInfo = (item) => {
    return api.post('/workbook/users/login', item);
}

export const putUserInfoChange = (item) => {
    return api.post('/workbook/users/change', item);
}
